import React, { useState, useEffect, useContext } from 'react';
import { fetchAuthSession } from "Services/auth.service";
import { Grid, Snackbar, Button, Typography } from "@material-ui/core";
import { LOGOUT } from 'context/actions';
import { Context } from "context";
import { SESSION_DURATION_MS } from 'global-constants/constants';
import styles from './LogoutSession.module.scss';

let intervalCheck;

const LogoutSession = () => {
  const {
    dispatch,
    state: { selectedCountry },
  } = useContext(Context);  
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const updateLastActiveTime = () => {
      localStorage.setItem(`lastActiveTime_${selectedCountry}`, Date.now());
    };

    window.addEventListener('mousemove', updateLastActiveTime);
    window.addEventListener('keydown', updateLastActiveTime);

    updateLastActiveTime();

    intervalCheck = setInterval(() => {
      const lastActiveTime = localStorage.getItem(`lastActiveTime_${selectedCountry}`) || 0;
      const tokenValidity = localStorage.getItem(`tokenValidity_${selectedCountry}`);

      if (tokenValidity - 1000 * 60 * 5 < lastActiveTime) {
        if (tokenValidity <= lastActiveTime) {
          handleLogOut();
        } else {
          handleOnIdle();
        }
      }
    }, 1000);

    return () => {
      clearInterval(intervalCheck);
      window.removeEventListener('mousemove', updateLastActiveTime);
      window.removeEventListener('keydown', updateLastActiveTime);
    };
  }, [selectedCountry]);

  const handleOnIdle = () => {
    if (!showModal)
      setShowModal(true)
  };

  const handleLogOut = () => dispatch({ type: LOGOUT });

  const retainSession = () => {
    setShowModal(false);

    localStorage.setItem(`tokenValidity_${selectedCountry}`, Date.now() + SESSION_DURATION_MS);

    refreshToken();
  };

  const refreshToken = async () => {
    try {
      const payload = {
        refresh_token: localStorage.getItem(`refreshToken_${selectedCountry}`) || ''
      }
      const response = await fetchAuthSession(payload);
      const id_token = response?.data?.id_token ?? '';
      const jwtToken = id_token.toString() || '';

      if (jwtToken)
        localStorage.setItem(
          `subscribiliToken_${selectedCountry}`,
          jwtToken
        );
      else
        throw new Error();
    } catch (e) {
      console.log('Unable to refresh Token', e);
    }
  };

  return (
    <>
      {showModal && (
        <Snackbar open={showModal} className={styles.snackbar}>
          <Grid container className={styles.container} >
            <Grid item xs={12} sm={12} md={5}>
              <Typography variant="h6">
                Session Time Out
              </Typography>

              <Typography variant="body2">
                Your session will expire in 5 minutes
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={7} className={styles.buttons}>
              <Grid container justify="flex-end">
                <Grid item xs={4}>
                  <Button
                    size="small"
                    variant="contained"
                    disableElevation
                    className={styles.secondarybutton}
                    onClick={handleLogOut}
                    data-testid='session-logout-button'
                  >
                    Logout
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    size="small"
                    variant="contained"
                    className={styles.primarybutton}
                    onClick={retainSession}
                    data-testid='session-restore-button'
                  >
                    Restore Session
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Snackbar>
      )}
    </>
  );
}

export default LogoutSession;